export const ComparativoIngresosGastosService = {
    getMonths,
    getYears,
    getGastos,
    getIngresos,
    getResumen
  }
  
  
  function euroFormat(number) {
    return new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR"}).format(number)
  }
  
  function getCommaSeparatedTwoDecimalsNumber(number) {
    const fixedNumber = number.toLocaleString("es-ES", { maximumFractionDigits: 2 });
    return String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  
  
  function getMonths(year, data) {
  
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
  
    return data
      .filter(element => element.year == year)
      .map(function (e) {
        return {
          month_id: e.month,
          month_name: monthNames[parseInt(e.month) - 1]
        }
      })
  }
  
  function removeDuplicates(yearList) {
    return yearList.filter((nombre, index) => {
      const _nombre = JSON.stringify(nombre);
      return index === yearList.findIndex(obj => {
        return JSON.stringify(obj) === _nombre;
      });
    });
  }
  
  function getYears(data) {
    if (!Array.isArray(data)) {
      console.error("Error: 'data' no es un arreglo. Tipo recibido:", typeof data, data);
      return []; // Retorna un arreglo vacío para evitar el error
    }
    return removeDuplicates(data.map(e => ({ nombre: e.year })));
  }
  
  function GetDataLineById(id, listOfData) {
    // retorna un elemento concreto de un mes contable a partir de su código
    return listOfData.find(obj => {
      return obj.code === id
    })
  }
  
  function isAnyo1(element, parametros) {
    return (element.month == parametros.month1.month_id) && (element.year == parametros.year1.nombre);
  }
  
  function isAnyo2(element, parametros) {
    return (element.month == parametros.month2.month_id) && (element.year == parametros.year2.nombre);
  }
  
  
  function getYear1Data(response, parametros, typeData) {
    console.log("getYear1Data - Inicio de función");
    console.log("Parámetros recibidos:", parametros);
    console.log("Tipo de dato de response:", typeof response, response);
  
    // Acceder a los datos internos de la respuesta
    const data = response.data;
    console.log("Datos extraídos de response:", data);
  
    // Validar si data es un arreglo
    if (!Array.isArray(data)) {
      console.error("Error: 'data' no es un arreglo. Tipo recibido:", typeof data, data);
      return [];
    }
  
    console.log("Data es un arreglo. Filtrando por año y mes con parametros:", parametros);
  
    // Filtrar y mapear los datos
    const filteredData = data.filter(element => isAnyo1(element, parametros));
    console.log("Datos filtrados:", filteredData);
  
    const mappedData = filteredData.map(e => ({
      year: e.year,
      data: e.data.filter(datoElement => datoElement.type === typeData)
    }));
  
    console.log("Datos mapeados con el tipo de dato:", typeData, mappedData);
    console.log("getYear1Data - Fin de función");
  
    return mappedData;
  }
  
  function getYear2Data(response, parametros, typeData) {
    console.log("getYear2Data - Inicio de función");
    console.log("Parámetros recibidos:", parametros);
    console.log("Tipo de dato de response:", typeof response, response);
  
    // Acceder a los datos internos de la respuesta
    const data = response.data;
    console.log("Datos extraídos de response:", data);
  
    // Validar si data es un arreglo
    if (!Array.isArray(data)) {
      console.error("Error: 'data' no es un arreglo. Tipo recibido:", typeof data, data);
      return [];
    }
  
    console.log("Data es un arreglo. Filtrando por año y mes con parametros:", parametros);
  
    // Filtrar y mapear los datos
    const filteredData = data.filter(element => isAnyo2(element, parametros));
    console.log("Datos filtrados:", filteredData);
  
    const mappedData = filteredData.map(e => ({
      year: e.year,
      data: e.data.filter(datoElement => datoElement.type === typeData)
    }));
  
    console.log("Datos mapeados con el tipo de dato:", typeData, mappedData);
    console.log("getYear2Data - Fin de función");
  
    return mappedData;
  }
  
  
  function percentajeVariation(value1, value2) {
    if (value2 == 0)
      if (value1 == 0)
        return "0%"
      else
        return "100%"
    else
      return getCommaSeparatedTwoDecimalsNumber(((- value2 + value1) / value2) * 100.0) + "%"
  }
  
  function joinBothYears(year1Data, year2Data) {
    return year1Data[0].data.map(function (item) {
      return {
        isActive: true,
        desc: item.desc,
        year1: euroFormat(item.value),
        year2: euroFormat(GetDataLineById(item.code, year2Data[0].data).value),
        dif: euroFormat(GetDataLineById(item.code, year2Data[0].data).value - item.value),
        var: percentajeVariation(GetDataLineById(item.code, year2Data[0].data).value, item.value)
      }
    });
  }
  
  function GetDataContab(data, parametros, typeData) {
    const year1Data = getYear1Data(data, parametros, typeData);
    const year2Data = getYear2Data(data, parametros, typeData);
    return joinBothYears(year1Data, year2Data)
  }
  
  
  function getGastos(data, parametros) {
    return GetDataContab(data, parametros, "gastos");
  }
  
  function getIngresos(data, parametros) {
    return GetDataContab(data, parametros, "ingresos");
  }
  
  function getResumen(data, parametros) {
    return GetDataContab(data, parametros, "resumen");
  }